<style>
#generateAd .v--modal-box.v--modal {
  min-width: 600px;
  min-height: 270px;
}
#generateAd * {
  font-size: 12px;
}
#generateAd .v-text-field__slot textarea {
  text-align: center;
}
</style>

<template>
  <Modal
    modalName="generateAd"
    title="Wygeneruj ogłoszenie"
    :buttons="['clipboardNotice', 'save']"
    @copyToClipboard="copyToClipboard"
    @saved="createAd"
  >
    <div id="wrapper">
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <!-- <v-text-field label="Data wstrzymania dopływu wody" v-model="dateStart" type="date"></v-text-field> -->
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedStart"
                label="Data wstrzymania dopływu wody"
                @blur="dateStart = parseDate(dateFormattedStart)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateStart"
              @input="menu1 = false"
              color="#2a579a"
              locale="pl-pl"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <!-- <v-text-field label="Godzina wstrzymania dopływu wody" v-model="timeStart" type="time"></v-text-field> -->
          <v-menu
            ref="menuTimeStart"
            :close-on-content-click="false"
            v-model="menuTimeStart"
            :nudge-right="40"
            :return-value.sync="timeStart"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="timeStart"
              label="Godzina wstrzymania dopływu wody"
            ></v-text-field>
            <v-time-picker
              v-if="menuTimeStart"
              format="24hr"
              v-model="timeStart"
              color="#2a579a"
              full-width
              @change="$refs.menuTimeStart.save(timeStart)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs5>
          <!-- <v-text-field
            label="Planowana data przywrócenia dopływu wody"
            v-model="dateEnd"
            type="date"
          ></v-text-field>-->
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedEnd"
                label="Data przywrócenia dopływu wody"
                @blur="dateEnd = parseDate(dateFormattedEnd)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateEnd"
              @input="menu2 = false"
              color="#2a579a"
              locale="pl-pl"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <!-- <v-text-field
            label="Planowana godzina przywrócenia dopływu wody"
            v-model="timeEnd"
            type="time"
          ></v-text-field>-->
          <v-menu
            ref="menuTimeEnd"
            :close-on-content-click="false"
            v-model="menuTimeEnd"
            :nudge-right="40"
            :return-value.sync="timeEnd"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="timeEnd"
              label="Planowana godzina przywrócenia dopływu wody"
            ></v-text-field>
            <v-time-picker
              v-if="menuTimeEnd"
              format="24hr"
              v-model="timeEnd"
              color="#2a579a"
              full-width
              @change="$refs.menuTimeEnd.save(timeEnd)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-text-field
            label="Obszar"
            v-model="street"
            type="text"
          ></v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-select
            label="Przyczyna"
            :items="causeList"
            v-model="cause"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        v-if="cause == 'Inne'"
      >
        <v-flex xs12>
          <v-text-field
            label="Inna przyczyna"
            v-model="causeOther"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-textarea
        box
        name="notice-preview"
        label="Podgląd ogłoszenia"
        v-model="messagePreview"
        readonly
        auto-grow
      ></v-textarea>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    dateStart: undefined,
    dateEnd: undefined,
    street: undefined,
    timeStart: undefined,
    timeEnd: undefined,
    menuTimeStart: false,
    menuTimeEnd: false,
    cause: undefined,
    causeOther: "",
    causeList: ["Awaria sieci", "Prace remontowe", "Inne"],
    dateFormattedStart: undefined,
    dateFormattedEnd: undefined,
    menu1: false,
    menu2: false
  }),
  computed: {
    currentBasemap() {
      return this.$store.getters.getCurrentBasemap;
    },
    currentUser() {
      return this.$store.getters.getCurrentUsername;
    },
    messagePreview() {
      return `
Uwaga
w dniu ${this.dateFormattedStart || "..."} o godzinie ${this.timeStart ||
        "..."}
NASTĄPI PRZERWA W DOSTAWIE WODY
Powód: ${this.cause == "Inne" ? this.causeOther : this.cause || "..."}
Obszar: ${this.street || "..."}
Przewidywany termin wznowienia dostaw wody: ${this.dateFormattedEnd ||
        "..."}, godzina ${this.timeEnd || "..."}
ZA UTRUDNIENIA PRZEPRASZAMY
`;
    }
  },
  watch: {
    dateStart(val) {
      this.dateFormattedStart = this.formatDate(this.dateStart)
    },
    dateEnd(val) {
      this.dateFormattedEnd = this.formatDate(this.dateEnd)
    }
  },
  methods: {
    formatDate(date) {
      if(!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if(!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    validate() {
      if(
        !this.dateFormattedEnd ||
        !this.dateFormattedStart ||
        !this.street ||
        !this.timeStart ||
        !this.timeEnd ||
        !this.cause
      ) {
        this.$root.$emit("showSnackbar", "red", "Uzupełnij wszystkie pola");
        return false;
      }

      if(this.dateFormattedEnd < this.dateFormattedStart) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Data wstrzymania nie może być późniejsza niż data przywrócenia wody"
        );
        return false;
      }

      if(
        this.dateFormattedEnd == this.dateFormattedStart &&
        this.timeEnd < this.timeStart
      ) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Godzina wstrzymania nie może być późniejsza niż godzina przywrócenia wody"
        );
        return false;
      }
      if(this.cause == "Inne" && this.causeOther.trim().length < 1) {
        this.$root.$emit("showSnackbar", "red", "Uzupełnij przyczynę awarii");
        return false;
      }

      return true;

      return true;
    },
    createAd() {
      if(!this.validate()) {
        return;
      }

      let payload = {
        date: this.dateFormattedStart,
        resumption: this.dateFormattedEnd,
        street: this.street.trim(),
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        cause: this.cause == "Inne" ? this.causeOther.trim() : this.cause.trim()
      };
      this.$store.dispatch("generateAd", payload).then(res => {
        if(res.status == 200) {
          this.close();
        } else {
          this.$root.$emit("showSnackbar", "red", `${res.message}`);
        }
      });
    },
    close() {
      this.$modal.hide("generateAd");
      this.street = undefined;
      this.timeStart = undefined;
      this.timeEnd = undefined;
      this.dateStart = undefined;
      this.dateEnd = undefined;
      this.menuTimeStart = false;
      this.menuTimeEnd = false;
      this.cause = undefined;
      this.causeOther = "";
      this.dateFormattedStart = undefined;
      this.dateFormattedEnd = undefined;
      this.menu1 = false;
      this.menu2 = false;
    },
    copyToClipboard() {
      if(!this.validate()) {
        return;
      }

      let notice = `
<style>
.aquagis_notice {
  text-align: center;
}
</style>

<div class="aquagis_notice">
  <h2>Uwaga</h2>
  <h4>z powodu prac na sieci</h4>
  <p>W dniu ${this.dateStart} o godzinie ${this.timeStart}</p>
  <h3>NASTĄPI PRZERWA W DOSTAWIE WODY</h3>
  <h4>Obszar: ${this.street}</h4>
  <p>Przewidywany termin wznowienia dostaw wody: ${this.dateEnd}, godzina ${
        this.timeEnd
        }</p>
  <h3>ZA UTRUDNIENIA PRZEPRASZAMY</h3>
</div>
      `;
      const el = document.createElement("textarea");
      el.value = notice;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$root.$emit("showSnackbar", "#2a579a", "Skopiowano do schowka");
    }
  },
  mounted() {
    this.$on("copyToClipboard", this.copyToClipboard);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/GenerateAd.vue